module.exports = __webpack_public_path__ + "img/texture.e4eb3ac9.png";